import type { EnrichedHotel } from "@/types/tripPlanner";
import { HotelCard } from "./HotelCard";

export interface HotelListProps {
  hilton: EnrichedHotel[];
  comparable: EnrichedHotel[];
}

export function HotelList({ hilton, comparable }: HotelListProps): React.ReactElement {
  return (
    <div className="flex flex-col gap-4">
      {hilton.length > 0 && (
        <div>
          <h3 className="mb-2 text-sm font-semibold">Hilton options</h3>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {hilton.map((h) => (
              <HotelCard key={h.place_id} hotel={h} />
            ))}
          </div>
        </div>
      )}
      {comparable.length > 0 && (
        <div>
          <h3 className="mb-2 border-t border-border pt-4 text-sm font-semibold">Comparable non-Hilton</h3>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {comparable.map((h) => (
              <HotelCard key={h.place_id} hotel={h} />
            ))}
          </div>
        </div>
      )}
      {hilton.length === 0 && comparable.length === 0 && (
        <p className="text-sm text-muted-foreground">No matching hotels within the selected radius.</p>
      )}
    </div>
  );
}
